import { Controller } from "stimulus";
import { formatCurrency, getActiveCurrency } from "../../util/currency";
import { drawWatermark } from "../../template/charts/generic_chart";

const EXPONENT_CONFIG = { significantFigures: 4, maximumDecimalTrailingZeroes: 4 }
export default class extends Controller {
  connect() {
    const chartTarget = this.element;

    const WATERMARK_URL = "https://static.coingecko.com/coingecko-color.svg";
    const WATERMARK_WIDTH = 128.5;
    const WATERMARK_HEIGHT = 34;
    const WATERMARK_PADDING = 16;

    Promise.all([
      import("highcharts/highstock"),
      import("highcharts/modules/heatmap"),
      import("highcharts/modules/treemap"),
    ]).then(async (res) => {
      const Highcharts = res[0];
      const Heatmap = res[1].default;
      const Treemap = res[2].default;

      Heatmap(Highcharts);
      Treemap(Highcharts);


      const currency = getActiveCurrency();
      const url = new URL("https://api.coingecko.com/api/v3/global/tree_map_chart_data");
      url.searchParams.set("vs_currency", currency);

      const chartData = await fetch(url).then(response => response.json());
      Highcharts.chart({
        title: false,
        exporting: false,
        navigator: false,
        rangeSelector: false,
        scrollbar: false,
        credits: false,
        legend: false,

        chart: {
          events: {
            render: (e) => {
              const chart = e.target;
              const x = WATERMARK_PADDING;
              const y = chart.plotHeight - WATERMARK_HEIGHT - WATERMARK_PADDING;

              if (!chart.watermark) {
                chart.watermark = chart.renderer.image(WATERMARK_URL, 0, 0, WATERMARK_WIDTH, WATERMARK_HEIGHT).attr({ zIndex: 3 }).add();
              }

              chart.watermark.attr({ x, y });
            }
          },
          renderTo: chartTarget,
          margin: [0, 0, 0, 0]
        },

        colorAxis: {
          dataClasses: [
            { from: -Infinity, to: -20, color: "#7A092C" },
            { from: -20, to: -5, color: "#B7192F" },
            { from: -5, to: 0, color: "#FF3A33" },
            { from: 0, to: 5, color: "#00A83E" },
            { from: 5, to: 20, color: "#007844" },
            { from: 20, to: Infinity, color: "#00503D" }
          ]
        },

        plotOptions: { treemap: { animation: false } },
        series: [
          {
            type: "treemap",
            data: chartData,
            layoutAlgorithm: "squarified",
            dataLabels: {
              useHTML: true,
              formatter: function () {
                const coinName = this.point.name.toUpperCase();
                const percentChange = parseFloat(this.point.colorValue).toFixed(2);
                const percentChangeText = `${percentChange > 0 ? "+" : ""}${percentChange}%`;

                const smallFontSize = this.point.shapeArgs.width / 14.0;
                const largeFontSize = this.point.shapeArgs.width / 8.0;

                return `
                <div>
                  <div style="font-weight: 500; font-size: ${largeFontSize}px">${coinName}</div>
                  <div style="font-weight: 400; font-size: ${smallFontSize}px; text-align: center;">${percentChangeText}</div>
                </div>
              `;
              }
            }
          }
        ],

        tooltip: {
          useHTML: true,
          borderRadius: 16,
          padding: 0.5,
          formatter: function () {
            const decimals = this.point.price > 0 && this.point.price < 1 ? EXPONENT_CONFIG : false;
            const changeColor = this.point.colorValue >= 0 ? "gecko-up" : "gecko-down";

            const price = formatCurrency(this.point.price, currency, false, decimals);
            const marketCap = formatCurrency(this.point.value, currency, false, false, true);
            const percentChange = parseFloat(this.point.colorValue).toFixed(2);

            return `
            <div class="gecko-tooltip">
              <div class="title">
                ${this.point.coinName} (${this.point.name.toUpperCase()})
                <span class="${changeColor}">${percentChange > 0 ? "+" : ""}${percentChange}%</span>
              </div>

              <div>${I18n.t("charts.price")}: <span class="value">${price}</span></div>
              <div>${I18n.t("charts.market_cap")}: <span class="value">${marketCap}</span></div>
            </div>
          `;
          },
          style: {
            textAlign: "center",
            fontSize: "1rem"
          }
        }
      });
    });
  }
}
